import React, { useState, useEffect, Suspense, useMemo } from 'react';
import './App.css';
import AppRouteMain from './routes/index';
import { BrowserRouter } from 'react-router-dom';
import Loader from './components/Loader/Loader';
import { ToastContainer } from 'react-toastify';
import { StyledEngineProvider } from '@mui/material';
import { UserProvider } from './context/userContext';
import { RolesPermissionsProvider } from './context/rolePermissionContext';
import { SnackbarProvider } from './context/snackbarContext';
import 'react-toastify/dist/ReactToastify.css';
// import WebSocketComponent from './components/websockets/WebSocketComponent';
// import WebSocketContext from './context/WebSocketContext';
import { AutoLogoutProvider } from './context/autoLogoutContext';
import { SnackbarDualLineProvider } from './context/snackbarDualLineContext';
import { UserCreateEditProvider } from './context/userCreateEditContext';
import { EmployeeListProvider } from './context/employeeListContext';
import { SiteListProvider } from './context/siteListContext';
import { PatrolReportListProvider } from './context/PatrolReportListContext';

function App() {
  const [ws, setWs] = useState(null);

  const value = useMemo(() => ({ ws, setWs }), [ws]);

  return (
    <AutoLogoutProvider>
      <SnackbarProvider>
        <SnackbarDualLineProvider>
          <UserCreateEditProvider>
            <PatrolReportListProvider>
              <SiteListProvider>
                <EmployeeListProvider>
                  <UserProvider>
                    <RolesPermissionsProvider>
                      <StyledEngineProvider injectFirst>
                        <BrowserRouter>
                          {/* <WebSocketContext.Provider value={value}> */}
                          <Suspense fallback={<Loader />}>
                            {/* <WebSocketComponent /> */}
                            <AppRouteMain />
                            <ToastContainer />
                          </Suspense>
                          {/* </WebSocketContext.Provider> */}
                        </BrowserRouter>
                      </StyledEngineProvider>
                    </RolesPermissionsProvider>
                  </UserProvider>
                </EmployeeListProvider>
              </SiteListProvider>
            </PatrolReportListProvider>
          </UserCreateEditProvider>
        </SnackbarDualLineProvider>
      </SnackbarProvider>
    </AutoLogoutProvider>
  );
}

export default App;
